export default "__VITE_ASSET__DajGr3Eu__"